import { render } from "./PriceLabelParamPreviewButton.vue?vue&type=template&id=004eac64"
import script from "./PriceLabelParamPreviewButton.vue?vue&type=script&lang=ts"
export * from "./PriceLabelParamPreviewButton.vue?vue&type=script&lang=ts"

import "./PriceLabelParamPreviewButton.vue?vue&type=style&index=0&id=004eac64&lang=less"
script.render = render

export default script